import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    attachmentIds: {
      type: 'array',
      title: 'Lista załączników',
      items: {
        type: 'number'
      }
    },
    attachmentNames: {
      type: 'array',
      items: {
        type: 'string'
      },
      aggregate: {
        func: 'map',
        array: '$external.attachments',
        property: '$item.name',
        when: '$methods.includesAll(this.attachmentIds, [$item.id])'
      }
    }
  },
  allOf: [validationMessages]
};
